import TransactionsActionTypes from './transactions-types'

export const startTransactions = data => ({
    type: TransactionsActionTypes.START_TRANSACTIONS,
    payload: data,
})
export const successTransactions = data => ({
    type: TransactionsActionTypes.SUCCESS_TRANSACTIONS,
    payload: data,
})

/****************  Alert Transaction  ****************** */

export const startAlertTransaction = data => ({
    type: TransactionsActionTypes.START_ALERT_TRANSACTION,
    payload: data,
})

export const successAlertTransaction = data => ({
    type: TransactionsActionTypes.SUCCESS_ALERT_TRANSACTION,
    payload: data,
})

/****************  Transactions filtering   ****************** */

export const startFilteringTransactions = data => ({
    type: TransactionsActionTypes.START_FILTERING_TRANSACTIONS,
    payload: data,
})
export const successFilteringTransactions = data => ({
    type: TransactionsActionTypes.SUCCESS_FILTERING_TRANSACTIONS,
    payload: data,
})
export const failureFilteringTransactions = data => ({
    type: TransactionsActionTypes.ERROR_FILTERING_TRANSACTIONS,
    payload: data,
})

/****************  Pay Transaction  ****************** */

export const fetchPayTransaction = data => ({
    type: TransactionsActionTypes.FETCH_PAY_TRANSACTION,
    payload: data,
})

export const successPayTransaction = data => ({
    type: TransactionsActionTypes.SUCCESS_PAY_TRANSACTION,
    payload: data,
})

export const finishPayTransaction = data => ({
    type: TransactionsActionTypes.FINISH_PAY_TRANSACTION,
    payload: data,
})

/************ Transaction Note ***************** */

export const startPutTransactionNote = data => ({
    type: TransactionsActionTypes.START_PUT_TRANSACTION_NOTE,
    payload: data,
})

export const successPutTransactionNote = data => ({
    type: TransactionsActionTypes.SUCCESS_PUT_TRANSACTION_NOTE,
    payload: data,
})

export const failurePutTransactionNote = data => ({
    type: TransactionsActionTypes.ERROR_PUT_TRANSACTION_NOTE,
    payload: data,
})

export const finishPutTransactionNote = data => ({
    type: TransactionsActionTypes.FINISH_PUT_TRANSACTION_NOTE,
    payload: data,
})

/************ Cancel Transaction ***************** */

export const startCancelTransaction = data => ({
    type: TransactionsActionTypes.START_CANCEL_TRANSACTION,
    payload: data,
})

export const successCancelTransaction = data => ({
    type: TransactionsActionTypes.SUCCESS_CANCEL_TRANSACTION,
    payload: data,
})

export const failureCancelTransaction = data => ({
    type: TransactionsActionTypes.ERROR_CANCEL_TRANSACTION,
    payload: data,
})

export const finishCancelTransaction = data => ({
    type: TransactionsActionTypes.FINISH_CANCEL_TRANSACTION,
    payload: data,
})

/************ Complete Transaction ***************** */

export const startCompleteTransaction = data => ({
    type: TransactionsActionTypes.START_COMPLETE_TRANSACTION,
    payload: data,
})

export const successCompleteTransaction = data => ({
    type: TransactionsActionTypes.SUCCESS_COMPLETE_TRANSACTION,
    payload: data,
})

export const failureCompleteTransaction = data => ({
    type: TransactionsActionTypes.ERROR_COMPLETE_TRANSACTION,
    payload: data,
})

export const finishCompleteTransaction = data => ({
    type: TransactionsActionTypes.FINISH_COMPLETE_TRANSACTION,
    payload: data,
})

/************ Complete Transaction ***************** */

export const startApproveTransaction = data => ({
    type: TransactionsActionTypes.START_APPROVE_TRANSACTION,
    payload: data,
})

export const successApproveTransaction = data => ({
    type: TransactionsActionTypes.SUCCESS_APPROVE_TRANSACTION,
    payload: data,
})

export const failureApproveTransaction = data => ({
    type: TransactionsActionTypes.ERROR_APPROVE_TRANSACTION,
    payload: data,
})

export const finishApproveTransaction = data => ({
    type: TransactionsActionTypes.FINISH_APPROVE_TRANSACTION,
    payload: data,
})

/************ Fake Deposit ***************** */

export const startFakeDeposit = data => ({
    type: TransactionsActionTypes.START_FAKE_DEPOSIT,
    payload: data,
})

export const successFakeDeposit = data => ({
    type: TransactionsActionTypes.SUCCESS_FAKE_DEPOSIT,
    payload: data,
})

export const failureFakeDeposit = data => ({
    type: TransactionsActionTypes.ERROR_FAKE_DEPOSIT,
    payload: data,
})

export const finishFakeDeposit = data => ({
    type: TransactionsActionTypes.FINISH_FAKE_DEPOSIT,
    payload: data,
})

//******** Dowload transaction pdf ***********
export const startDownloadPdfTransaction = data => ({
    type: TransactionsActionTypes.START_DOWNLOAD_PDF_TRANSACTION,
    payload: data,
})

export const successDownloadPdfTransaction = data => ({
    type: TransactionsActionTypes.SUCCESS_DOWNLOAD_PDF_TRANSACTION,
    payload: data,
})

export const finishDownloadPdfTransaction = data => ({
    type: TransactionsActionTypes.FINISH_DOWNLOAD_PDF_TRANSACTION,
    payload: data,
})

export const failureDownloadPdfTransaction = data => ({
    type: TransactionsActionTypes.ERROR_DOWNLOAD_PDF_TRANSACTION,
    payload: data,
})

//******** Fetch statement PDF ***********
export const startGetPdfStatement = data => ({
    type: TransactionsActionTypes.START_GET_PDF_STATEMENT,
    payload: data,
})

export const successGetPdfStatement = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_PDF_STATEMENT,
    payload: data,
})

export const failureGetPdfStatement = data => ({
    type: TransactionsActionTypes.ERROR_GET_PDF_STATEMENT,
    payload: data,
})

export const finishGetPdfStatement = data => ({
    type: TransactionsActionTypes.FINISH_GET_PDF_STATEMENT,
    payload: data,
})

//******** Fetch statement TXT ***********
export const startGetTxtStatement = data => ({
    type: TransactionsActionTypes.START_GET_TXT_STATEMENT,
    payload: data,
})

export const successGetTxtStatement = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_TXT_STATEMENT,
    payload: data,
})

export const failureGetTxtStatement = data => ({
    type: TransactionsActionTypes.ERROR_GET_TXT_STATEMENT,
    payload: data,
})

export const finishGetTxtStatement = data => ({
    type: TransactionsActionTypes.FINISH_GET_TXT_STATEMENT,
    payload: data,
})

//******** Fetch statement XML ***********
export const startGetXmlStatement = data => ({
    type: TransactionsActionTypes.START_GET_XML_STATEMENT,
    payload: data,
})

export const successGetXmlStatement = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_XML_STATEMENT,
    payload: data,
})

export const failureGetXmlStatement = data => ({
    type: TransactionsActionTypes.ERROR_GET_XML_STATEMENT,
    payload: data,
})

export const finishGetXmlStatement = data => ({
    type: TransactionsActionTypes.FINISH_GET_XML_STATEMENT,
    payload: data,
})

//******** Fetch statement CSV ***********
export const startGetCsvStatement = data => ({
    type: TransactionsActionTypes.START_GET_CSV_STATEMENT,
    payload: data,
})

export const successGetCsvStatement = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_CSV_STATEMENT,
    payload: data,
})

export const failureGetCsvStatement = data => ({
    type: TransactionsActionTypes.ERROR_GET_CSV_STATEMENT,
    payload: data,
})

export const finishGetCsvStatement = data => ({
    type: TransactionsActionTypes.FINISH_GET_CSV_STATEMENT,
    payload: data,
})

//******** Get files ***********
export const startGetFiles = data => ({
    type: TransactionsActionTypes.START_GET_FILES,
    payload: data,
})

export const successGetFiles = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_FILES,
    payload: data,
})

export const failureGetFiles = data => ({
    type: TransactionsActionTypes.FINISH_GET_FILES,
    payload: data,
})

export const finishGetFiles = data => ({
    type: TransactionsActionTypes.ERROR_GET_FILES,
    payload: data,
})

//******** Get Counts ***********
export const startGetCounts = data => ({
    type: TransactionsActionTypes.START_GET_COUNTS,
    payload: data,
})

export const successGetCounts = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_COUNTS,
    payload: data,
})

export const failureGetCounts = data => ({
    type: TransactionsActionTypes.FINISH_GET_COUNTS,
    payload: data,
})

export const finishGetCounts = data => ({
    type: TransactionsActionTypes.ERROR_GET_COUNTS,
    payload: data,
})

//******** Get Statuses ***********
export const startGetStatuses = data => ({
    type: TransactionsActionTypes.START_GET_STATUSES,
    payload: data,
})

export const successGetStatuses = data => ({
    type: TransactionsActionTypes.SUCCESS_GET_STATUSES,
    payload: data,
})

export const failureGetStatuses = data => ({
    type: TransactionsActionTypes.FINISH_GET_STATUSES,
    payload: data,
})

export const finishGetStatuses = data => ({
    type: TransactionsActionTypes.ERROR_GET_STATUSES,
    payload: data,
})
